Ext.define('SA.ProjectAttributesProxy', {
    constructor({project, changeHandler}) {
        this.project = project;
        this.listener = SA.ListenerFactory.create(project, 'change:attribute', changeHandler);
    },

    addAttribute(attribute) {
        this.addAttributes([attribute]);
    },

    addAttributes(attributes) {
        this.listener.pause();
        this.project.addAttributes(attributes);
        this.listener.resume();
    },

    destroy() {
        this.listener.destroy();
    }
});